import { render } from "./RFICards.vue?vue&type=template&id=52f85bfa"
import script from "./RFICards.vue?vue&type=script&lang=js"
export * from "./RFICards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__